import React from 'react'
import { CurrencyText } from '../../../Global'

export const TableDataCellBudget = ({ dataValue }: { dataValue?: number }) => {
  return <CurrencyText value={Number(dataValue)} />
}
